import angular from 'angular'

import { wrDebugToolsModuleRegistry } from '../../../factories/application/wr-debug-tools'
import { ServiceWorkerManagerService as ServiceWorkerManager } from './service-worker-manager.service'

export const serviceWorkerManager = new ServiceWorkerManager()

wrDebugToolsModuleRegistry.register(
  'serviceWorkerManager',
  serviceWorkerManager
)

angular
  .module('webregister.components')
  .factory('serviceWorkerManager', () => serviceWorkerManager)
